import React, { useMemo } from 'react';
import DataVisualizationView from '../../components/common/DataVisualizationView';
import Table from '../../components/common/Table';
import { useIsScreenAboveBreakpoint } from '../../hooks';
import AnimatedCircularProgress from '../../components/common/AnimatedCircularProgress';
import { tables } from '../../constants';

/**
 * Usage History Component
 *
 * This component is part of the data visualization stucture and is specifically
 * designed to handle the "Usage History" data. It currently renders a table to
 * display the data but will support graph visualizations in the future.
 *
 * Reponsabilities:
 * - Define how the "Usage History" data is presented.
 * - Render the appropiate components (e.g., Table, Graphs) for this data type.
 *
 * Future enhancements:
 * - Integration of graphs to complement or replace the table for better data insights.
 *
 * @returns {JSX.Element}
 */
const FilterLife = () => {
  const screenIsAbove768Breapoint = useIsScreenAboveBreakpoint();

  const circleProps = useMemo(
    () => ({
      ...(screenIsAbove768Breapoint && {
        containerSize: 'w-[350px] h-[350px]',
        radius: '120',
        progressCircleStroke: '25',
        innerCirclePosition: 20,
        innerCircleStroke: '3',
        textSize: 'text-6xl',
      }),
    }),
    [screenIsAbove768Breapoint],
  );

  return (
    <DataVisualizationView dataType={tables.filter}>
      {(props) => {
        const latestFilterLifeRecord = props?.data[0]?.percentage || 0;
        return (
          <>
            <div className="flex flex-col md:flex-row h-full">
              <div className="w-full md:w-2/5 flex justify-center items-center">
                <div className="flex flex-col items-center justify-center w-full max-w-xs sm:max-w-sm md:max-w-md">
                  <AnimatedCircularProgress
                    percentage={latestFilterLifeRecord}
                    mode="dark"
                    {...circleProps}
                  />
                </div>
              </div>
              <div className="w-full md:w-3/5">
                <Table {...props} data={props.currentRecords} />
              </div>
            </div>
          </>
        );
      }}
    </DataVisualizationView>
  );
};

export default FilterLife;
